import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import { userAccess } from "../../../utils/CommonFunction";

type Props = {
  enablePassword?: () => void;
};

const UserInfo = (props: Props) => {
  const { firstName, lastName, email, companyName, role, logo } = userAccess();

  return (
    <Card
      sx={{
        margin: "auto",
        width: "100%",
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
      }}
    >
      <CardContent>
        <Grid container alignItems="center" spacing={3}>
          {/* Logo on the left */}
          <Grid item>
            <Avatar
              src={logo}
              alt={companyName}
              sx={{ width: 64, height: 64 }}
            />
          </Grid>
          {/* Info on the right */}
          <Grid item xs>
            <Typography variant="body1" gutterBottom>
              <strong>Name:</strong> {firstName} {lastName}
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>Email:</strong> {email}
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>Company:</strong> {companyName}
            </Typography>
            <Typography variant="body1">
              <strong>Role:</strong> {role}
            </Typography>
            {/* Password change button at the end, right aligned */}
            <Box mt={2} display="flex" justifyContent="flex-end">
              <Button
                variant="text"
                color="primary"
                onClick={props.enablePassword}
              >
                Change Password
              </Button>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default UserInfo;
